import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-16d449b0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_label = _resolveComponent("ion-label")
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_icon = _resolveComponent("ion-icon")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_list = _resolveComponent("ion-list")

  return (_openBlock(), _createBlock(_component_ion_list, { class: "gameItem" }, {
    default: _withId(() => [
      _createVNode(_component_ion_grid, null, {
        default: _withId(() => [
          _createVNode(_component_ion_row, null, {
            default: _withId(() => [
              _createVNode(_component_ion_col, {
                size: "3",
                class: "flex ion-justify-content-center ion-align-items-center ion-no-padding"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_label, null, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.game.name), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "3" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_input, {
                        class: "ion-text-center",
                        type: "number",
                        min: "0",
                        modelValue: _ctx.game.pointA,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.game.pointA = $event)),
                        modelModifiers: { number: true },
                        onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.checkGame(_ctx.game)))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, { size: "3" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_input, {
                        class: "ion-text-center",
                        type: "number",
                        min: "0",
                        modelValue: _ctx.game.pointB,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.game.pointB = $event)),
                        modelModifiers: { number: true },
                        onIonChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkGame(_ctx.game)))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "3",
                class: "flex ion-justify-content-center ion-align-items-center ion-no-padding"
              }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    size: "small",
                    fill: "clear",
                    class: "validIcon"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        name: _ctx.game.valid ? 'checkmark' : 'close-circle',
                        color: _ctx.game.valid ? 'success' : 'danger',
                        slot: "icon-only"
                      }, null, 8, ["name", "color"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})